import axios from 'axios'

export const state = {
  logs: null,
  pagination: null,
}

export const getters = {
  logs: (state) => state.logs,
  logsPagination: (state) => state.pagination,
}

export const mutations = {
  SET_LOGS(state, logs) {
    state.logs = logs
  },

  SET_PAGINATION(state, headers) {
    state.pagination = {
      currentPage: parseInt(headers['x-current-page']),
      nextPage: parseInt(headers['x-next-page']),
      prevPage: parseInt(headers['x-prev-page']),
      totalItems: parseInt(headers['x-total-items']),
      totalPages: parseInt(headers['x-total-pages']),
      perPage: parseInt(headers['x-per-page']),
    }
  },
}

export const actions = {
  fetchAllLogs({ commit, state, rootState }, { userId, page, perPage }) {
    return axios
      .get(`/api/actions/${userId}`, {
        params: { page, per_page: perPage },
      })
      .then((response) => {
        const logs = response.data
        commit('SET_LOGS', logs)
        commit('SET_PAGINATION', response.headers)
        return logs
      })
  },

  createLog({ commit, state, rootState }, { userId, title }) {
    return axios.post(`/api/actions/${userId}`, {
      details: JSON.stringify({ title }),
    })
  },

  updateLog({ commit, state, rootState }, { userId, id, title }) {
    return axios.post(`/api/actions/${userId}/${id}`, {
      details: JSON.stringify({ title }),
    })
  },

  deleteLog({ commit, state, rootState }, { userId, id }) {
    return axios.delete(`/api/actions/${userId}/${id}`)
  },
}
